import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';

import HomePage       from './pages/HomePage';
import GamesPage      from './pages/GamesPage';
import GameDetailPage from './pages/GameDetailPage';
import NewsPage       from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import NotFound       from './pages/NotFound';
import EnginePage     from './pages/EnginePage';
import DrumKit        from './pages/games/DrumKit';
import MemoryGame     from './pages/games/MemoryGame';
import TicTacToe      from './pages/games/TicTacToe';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; overflow-x: hidden; }
  body {
    background: ${({ theme }) => theme.colors.darker};
    color: ${({ theme }) => theme.colors.textPrimary};
    font-family: ${({ theme }) => theme.fonts.body};
    overflow-x: hidden;
  }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: ${({ theme }) => theme.colors.darker}; }
  ::-webkit-scrollbar-thumb { background: ${({ theme }) => theme.colors.blue}; border-radius: 2px; }
  a, button { text-decoration: none; border: none; background: none; }
  img { max-width: 100%; display: block; }
`;

function LangSync() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language === 'en' ? 'en' : 'pt-BR';
  }, [i18n.language]);
  return null;
}

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <LangSync />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/"                  element={<HomePage />} />
          <Route path="/games"             element={<GamesPage />} />
          <Route path="/games/:id"         element={<GameDetailPage />} />
          <Route path="/engine"            element={<EnginePage />} />
          <Route path="/news"              element={<NewsPage />} />
          <Route path="/news/:id"          element={<NewsDetailPage />} />
          <Route path="/store"             element={<ExternalRedirect to="https://store.games.guebly.com.br" />} />
          <Route path="/developer"         element={<ExternalRedirect to="https://dev.games.guebly.com.br" />} />
          <Route path="/play/drum-kit"     element={<DrumKit />} />
          <Route path="/play/memory-game"  element={<MemoryGame />} />
          <Route path="/play/tic-tac-toe"  element={<TicTacToe />} />
          <Route path="*"                  element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
